import { sharedMonthlySource } from "../lib/rounds";
import { createNextCandleLoop, resolveNextCandle } from "./predictNextCandleStores";

/**
 * The Predict monthly Next-Candle Loop: 36 monthly Context candles, guess the
 * next candle green/red, reveal it. The weekly Loop's twin over the monthly
 * bank, with its own persisted score/Streak.
 */

/** Resolve a monthly commitment: the answer is the Round's first Forward candle. */
export const resolvePredictMonthly = resolveNextCandle;

export const usePredictMonthlyStore = createNextCandleLoop({
  timeframe: "monthly",
  openSource: sharedMonthlySource,
  seenKey: "seen:monthly",
  scoreKey: "predict-monthly:score",
  streakKey: "predict-monthly:streak",
});
